/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentTypeSerializerDetail } from './appointmentTypeSerializerDetail';
import { CancellationReasonEnum } from './cancellationReasonEnum';
import { Practice } from './practice';
import { AppointmentStatusEnum } from './appointmentStatusEnum';
import { AppointmentListTherapist } from './appointmentListTherapist';
import { CalendarPatient } from './calendarPatient';


/**
 * Serializer for the appointment overview list.  Covers the frontend table columns: appointment (start_date/end_date), duration (end_date - start_date), session type and treatment type (both on appointment_type), patient, practice, therapist, status, cancellation reason and appointment type name.  Note that ``end_date`` is computed on save as ``start_date + length_in_min`` and ignores ``is_double_session``, so a double session shows single length.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentList { 
    readonly id: number;
    startDate: string;
    readonly endDate: string;
    readonly appointmentStatus: AppointmentStatusEnum;
    readonly appointmentType: AppointmentTypeSerializerDetail;
    readonly cancellationReason: CancellationReasonEnum | null;
    cancellationReasonOther?: string | null;
    readonly practice: Practice;
    readonly patient: CalendarPatient | null;
    therapist: AppointmentListTherapist;
}
export namespace AppointmentList {
}

export const AppointmentList_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentList_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentList_endDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentList_appointmentStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentList_appointmentType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentList_cancellationReason_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentList_cancellationReasonOther_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const AppointmentList_practice_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentList_patient_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentList_therapist_Validators: ValidatorFn[] =
    [  Validators.required, ];


